import { Outlet, createFileRoute } from '@tanstack/react-router'
import * as v from 'valibot'

import { Divider } from '@masterplandev/ui'

import { Layout, Main, MainContent } from '@/app/manager/Layout'
import { LearnpathCreatorBody } from '@/learnpaths-creator/components/LearnpathsCreatorLayout/LearnpathCreatorBody'
import {
  LearnpathCreatorHeader,
  LearnpathCreatorHeaderBackLink,
  LearnpathCreatorHeaderNote,
  LearnpathCreatorHeaderProgress,
  LearnpathCreatorHeaderStatus,
  LearnpathCreatorHeaderTitle,
} from '@/learnpaths-creator/components/LearnpathsCreatorLayout/LearnpathCreatorHeader'
import { LearnpathsCreatorHeaderLanguage } from '@/learnpaths-creator/components/LearnpathsCreatorLayout/LearnpathCreatorHeaderLanguage'
import { LearnpathsCreatorLanguageProvider } from '@/learnpaths-creator/contexts/LearnpathsCreatorLanguageContext'
import { DialogProvider } from '@/learnpaths-summary/contexts/Dialog'
import { useIsLearnpathCreatorAvailable } from '@/learnpaths/hooks/useIsLearnpathCreatorAvailable'
import { CONTENT_LOCALE } from '@/locale/constants'
import { NotFound } from '@/router/NotFound'

const searchSchema = v.object({
  lang_edit: v.optional(v.picklist(CONTENT_LOCALE)),
})

export const Route = createFileRoute('/company/learnpaths/add')({
  validateSearch: searchSchema,
  component: LearnpathsCreator,
})

function LearnpathsCreator() {
  const isLearnpathEnabled = useIsLearnpathCreatorAvailable()

  if (!isLearnpathEnabled) {
    return <NotFound />
  }

  return (
    <DialogProvider>
      <LearnpathsCreatorLanguageProvider>
        <Layout data-testid="learnpath-creator-layout">
          <Main>
            <LearnpathCreatorHeader>
              <LearnpathCreatorHeaderBackLink />
              <Divider orientation="vertical" h="6" />
              <LearnpathCreatorHeaderTitle />
              <LearnpathCreatorHeaderStatus />
              <LearnpathCreatorHeaderProgress />
              <LearnpathsCreatorHeaderLanguage />
            </LearnpathCreatorHeader>
            <LearnpathCreatorHeaderNote />
            <MainContent>
              <DialogProvider>
                <LearnpathCreatorBody>
                  <Outlet />
                </LearnpathCreatorBody>
              </DialogProvider>
            </MainContent>
          </Main>
        </Layout>
      </LearnpathsCreatorLanguageProvider>
    </DialogProvider>
  )
}
